import * as z from "zod";

// The Shopify product metafields an account has defined, mirrored into CRDB by
// the hourly IMS sync. Merchants read these as `namespace.key`.

export const productMetafieldDefinitionSchema = z.object({
  namespace: z.string(),
  key: z.string(),
});
export type ProductMetafieldDefinition = z.infer<
  typeof productMetafieldDefinitionSchema
>;
